const NewsVideosPage = () => {
  return (
    <>
      <script src="https://go.screenpal.com/player/appearance/cTnh6wnfWje"></script>
      <iframe
        src="https://go.screenpal.com/channels/cTh0QzVZhp/show-sidebar"
        title="Online disponering, ruteplanlægning og fakturering"
        height="100%"
        width="100%"
        allow="autoplay; fullscreen"
      ></iframe>
    </>
  );
};

export default NewsVideosPage;
